import { CSSProperties } from 'react'
import cn from 'classnames'
import genericSs from '../../assets/styles/generic.module.scss'
import { getOptionColorBg, getOptionColorText } from '../../constants/customFields'
import styles from './CustomFieldOptionPill.module.scss'

interface IProps {
  name: string
  // Palette key stored on the option.
  color: string
}

// Colored pill for a single/multi-select option value — the same visual role and
// base styling as the task Status pill (shared `reportingStatus` + `pill` classes,
// including the in-cell font-size bump), so both selects look identical. Only the
// fill/text color is data-driven (custom properties), with auto-contrast text so light chips
// stay readable.
const CustomFieldOptionPill = ({ name, color }: IProps) => (
  <span
    // Full name on hover, for wherever the pill is too narrow to show it.
    title={name}
    className={cn(genericSs.reportingStatus, styles.pill)}
    style={
      {
        '--pill-bg': getOptionColorBg(color),
        '--pill-text': getOptionColorText(color),
      } as CSSProperties
    }
  >
    {name}
  </span>
)

export default CustomFieldOptionPill
